import { useMergeProvidersMutation } from '../../../../graphql'
import { useShowSuccess, useShowError } from 'hooks/useToast'

export default function useMergeProvidersHandler() {
	const [ mergeProviders ] = useMergeProvidersMutation()
	const showError = useShowError()
	const showSuccess = useShowSuccess()

	return async( goodProviderId: number, duplicateProviderId: number ) => {
		const result = await mergeProviders( {
			variables: {
				goodProviderId,
				duplicateProviderId,
			},
		} )

		if ( result.data?.mergeProviders?.success ) {
			showSuccess( `mergeProvidersSuccess${Date.now()}`, result.data?.mergeProviders?.message ?? 'Successfully merged manufacturers!' )
		} else {
			showError( `mergeProvidersError${Date.now()}`, result.data?.mergeProviders?.message ?? 'Sorry, an error occurred' )
		}
	}
}
